import React from "react";
import { Card, Button, Row, Col, Tag, Divider } from "antd";
import {
  EnvironmentOutlined,
  BookOutlined,
  SolutionOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import "./AdvertCard.css";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../utils/routes";

const AdvertCard = ({ advert, isApplied = false }) => {
  const navigate = useNavigate();
  if (!advert) {
    return;
  }
  const {
    firmUser: {
      firm: { companyName, imageUrl },
    },
    position: { name: positionName },
    jobType: { description: jobType },
    durationType: { description: durationType },
    wageType: { description: wageType },
    wagePeriod: { description: wagePeriod },
    minWage,
    maxWage,
    wage,
    currency,
    jobDuration,
    title,
    district,
    city,
    country,
    minEducationLevel,
    isExperienceRequired,
    keywords,
    experienceYear,
    id: advertId,
  } = advert;

  const wageAmount = wage !== null ? wage : `${minWage}-${maxWage} `;

  const location =
    district !== null
      ? `${district.name} / ${district.city.name}`
      : city !== null
      ? city.name
      : country.name;

  const education =
    minEducationLevel !== null
      ? minEducationLevel.description
      : "Eğitim Tercihi Yok";

  const experience = isExperienceRequired
    ? `${experienceYear} Yıllık Deneyim`
    : "Deneyim Aranmıyor";

  const goToDetailPage = () => {
    let path = `${PageRoutes.advertDetailEmployee}/${advertId}`;
    navigate(path);
  };

  return (
    <Card className="advert-card">
      <Row>
        <p style={{ fontSize: "14px", marginBottom: "8px", marginTop: "0px" }}>
          Şirket: {companyName}
        </p>

        <Divider style={{ marginBottom: "10px", marginTop: "0px" }} />
      </Row>

      <Row>
        <Col
          style={{
            display: "flex",
            justifyContent: "center",
            marginRight: 10,
          }}>
          <img
            style={{
              maxWidth: 64,
              objectFit: "contain",
            }}
            src={imageUrl}
            alt=""
          />
        </Col>
        <Col style={{ flexGrow: 1 }}>
          <Row className="advert-card-row">
            <Col>
              <h2>{positionName}</h2>

              <p>{title}</p>

              <Row className="skills-row" gutter={[0, 4]}>
                {keywords.map((item, index) => (
                  <Tag key={index} color="blue">
                    {item}
                  </Tag>
                ))}
              </Row>
            </Col>

            <Col>
              <Button
                onClick={() => {
                  goToDetailPage();
                }}
                type="primary"
                shape="round"
                size="large">
                İncele
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={12} className="details-row">
        <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
        <Col className="icon-text">
          <EnvironmentOutlined style={{ marginRight: 3, fontSize: "12px" }} />
          <span>{location}</span>
        </Col>

        <Col className="icon-text">
          <BookOutlined style={{ marginRight: 3, fontSize: "12px" }} />
          <span>{education}</span>
        </Col>

        <Col className="icon-text">
          <SolutionOutlined style={{ marginRight: 3, fontSize: "12px" }} />
          <span>{experience}</span>
        </Col>
        <Col className="icon-text">
          <TeamOutlined style={{ marginRight: 3, fontSize: "12px" }} />
          <span>{jobType}</span>
        </Col>
        <Col className="icon-text">
          <ClockCircleOutlined style={{ marginRight: 3, fontSize: "12px" }} />
          <span>{jobDuration + " " + durationType}</span>
        </Col>
        <Col className="icon-text">
          <DollarOutlined style={{ marginRight: 3, fontSize: "12px" }} />
          <span>
            {wagePeriod + " " + wageType + " " + wageAmount + " " + currency}
          </span>
        </Col>
      </Row>
      {isApplied && (
        <>
          {" "}
          <Divider orientation="left">Ön Yazı</Divider>
          {advert.coverLetter}
        </>
      )}
    </Card>
  );
};

export default AdvertCard;
